<template>
  <div id="ring-left-menu">
    <el-aside width="224px">
      <div class="logo">
        <router-link :to="{ name: 'HomePage' }">
          <img src="../../assets/logo-big.png">
        </router-link>
      </div>
      <el-menu
          mode="vertical"
          :router="true"
          :default-active="defaultActiveMenuItem">
        <el-menu-item
            v-for="item in menuItems"
            :key="item.name"
            :index="item.index.toString()"
            :route="{ name: item.name, params: { id: customer.id } }">
          <img :src="item.icon">
          <div class="indicator" />

          <!--<i :class="item.icon"/>-->
          <span>{{ $t(item.i18n) }}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapGetters: accountGetters } = createNamespacedHelpers("db/account");

export default {
  name: "MainLeftMenu",
  data() {
    return {
      defaultActiveMenuItem: "1",
      routeNames: {
        Dashboard: "Dashboard",
        CustomerProfile: "CustomerProfile",
        Devices: "Devices",
        Device: "Devices",
        CustomerRequests: "CustomerRequests",
        CustomerHistory: "CustomerHistory",
      },
      menuItems: [
        {
          index: 1,
          name: "Dashboard",
          id: "",
          icon: require("@/assets/icons/devices.svg"),
          i18n: "common.dashboard",
        },
        {
          index: 2,
          name: "CustomerProfile",
          id: "",
          icon: require("@/assets/icons/account.svg"),
          i18n: "common.account",
        },
        {
          index: 3,
          name: "Devices",
          id: "",
          icon: require("@/assets/icons/devices-section.svg"),
          i18n: "common.devices",
        },
        {
          index: 4,
          name: "CustomerHistory",
          id: "",
          icon: require("@/assets/icons/history.svg"),
          i18n: "common.history",
        },
        {
          index: 5,
          name: "CustomerRequests",
          id: "",
          icon: require("@/assets/icons/requests.svg"),
          i18n: "common.requests",
        },
      ],
    };
  },
  computed: {
    ...accountGetters(["customer"]),
  },
  watch: {
    $route(to) {
      const menuItemName = this.routeNames[to.name];
      if (menuItemName) this.setActiveMenuItem();
    },
  },
  updated() {
    this.setActiveMenuItem();
  },
  created() {
    this.setActiveMenuItem();
  },
  methods: {
    setActiveMenuItem() {
      this.selectMenuItemIndex(this.$route.name);
    },
    selectMenuItemIndex(routeName) {
      const menuItemName = this.routeNames[routeName];
      if (!menuItemName) {
        console.error("Menu item not identified.");
        return;
      }

      const menuItem = this.menuItems.find(
        (item) => item.name === menuItemName
      );

      if (!menuItem) {
        console.error("Menu item not indentified.");
        return;
      }

      this.defaultActiveMenuItem = String(menuItem.index);
    },
  },
};
</script>

<style lang="scss">
#ring-left-menu {
  .el-aside {
    border-right: solid 1px #e4e4e4;
    background: #fff;
    height: 100vh;
    padding: 0px;
  }
  .logo {
    padding-left: 40px;
    padding-top: 15px;
    margin-bottom: 35px;
    img {
      height: 55px;
      margin: 0px auto;
    }
  }
  .el-menu {
    border: none;
  }
  .el-menu-item {
    font-size: 18px;
    color: $--color-curious-blue;
    padding-left: 32px !important;
    margin-bottom: 35px;
    background: white;
    &:hover {
      background: $--color-athens-gray;
    }
    img {
      padding-right: 20px;
    }
  }

  /*.el-aside .el-menu .el-menu-item.is-active {*/
  /*border-left: solid 10px #1998d5;*/
  /*}*/

  .el-menu-item .indicator {
    float: left;
  }
  .el-aside .el-menu .el-menu-item.is-active #indicator {
    /*background: #1998d5;*/
    /*box-shadow: 2px 3px 11px 0 rgba(1, 172, 253, 0.74);*/
  }

  .el-menu-item.is-active div.indicator {
    top: 0;
    left: 0;
    position: absolute;
    content: url("../../assets/icons/selected_left_menu_item.svg");
  }

  /*.el-menu-item.is-active div.indicator {*/
  /*float: left;*/
  /*content: url("../../assets/icons/selected_left_menu_item.svg");*/
  /*}*/
}
</style>
